export default __webpack_public_path__ + "static/media/LogoWhite.a212af25.svg";